/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Role_OwnerInputs */

const en_mk_sec_pg_role_owner = /** @type {(inputs: Mk_Sec_Pg_Role_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner`)
};

const id_mk_sec_pg_role_owner = /** @type {(inputs: Mk_Sec_Pg_Role_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemilik`)
};

/**
* | output |
* | --- |
* | "Owner" |
*
* @param {Mk_Sec_Pg_Role_OwnerInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_role_owner = /** @type {((inputs?: Mk_Sec_Pg_Role_OwnerInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Role_OwnerInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_role_owner(inputs)
	return en_mk_sec_pg_role_owner(inputs)
});